import React from 'react';
import { Section } from './ui/Section';
export function ProofSection() {
  return <Section className="px-6 md:px-12 max-w-4xl mx-auto" data-id="element-230">
      <div className="p-8 md:p-12 border-l-2 border-[#d4a853] bg-gradient-to-r from-[#111827] to-transparent" data-id="element-231">
        <p className="font-serif text-2xl md:text-3xl text-gray-200 leading-relaxed italic" data-id="element-232">
          "En los próximos 7 días, vas a pasar de responder mensajes manuales a
          recibir notificaciones de{' '}
          <span className="text-[#f0c674] not-italic font-semibold" data-id="element-233">
            'Pago Recibido'
          </span>{' '}
          mientras tu sistema entrega el acceso al cliente de forma instantánea.
          <br data-id="element-234" />
          <br data-id="element-235" />
          <span className="text-[#d4a853] not-italic font-medium" data-id="element-236">
            No es magia, es ingeniería de procesos aplicada a tu libertad.
          </span>
          "
        </p>
      </div>
    </Section>;
}